import { Icon, IconButton } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { FaArrowCircleUp } from 'react-icons/fa'; // Optional: using react-icons for an arrow icon

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => {
    // Show button if the user scrolls down more than 400 pixels
    if (window.pageYOffset > 400) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    // Cleanup the event listener when the component unmounts
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
        behavior: 'smooth' // Smooth scroll to top
    });
  };


  return (
    <IconButton
        pos={'fixed'}
        rounded={'full'}
        bottom={16}
        opacity={0.7}
        right={4}
        zIndex={1000}
        visibility={isVisible ? 'visible' : 'hidden'}
        onClick={scrollToTop}
    >   
        <Icon>
            <FaArrowCircleUp />
        </Icon>
    </IconButton>
  );
};

export default ScrollToTopButton;
